import React from "react";

export default function LearnOrgavitaz() {
  return (
    <div>
      {/* 🔹 Banner Section */}
      <div
        style={{
          backgroundImage: "url('/images/AboutOrgavitaz/About.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "70vh",
          position: "relative", // ✅ Needed for absolute positioning inside
          marginBottom: "3rem",
          color: "#fff",
        }}
      >
        {/* Banner Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></div>

        {/* Title at bottom of banner */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0,0,0,0.5)",
            padding: "1rem 2rem",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          <h1 className="display-6 m-0">Learn Orgavitaz</h1>
        </div>
      </div>

      {/* 🔹 Book-style Sections */}
     
     
    </div>
  );
}
